import { render, staticRenderFns } from "./apprenticeMakeMoney.vue?vue&type=template&id=13552984&scoped=true&"
import script from "./apprenticeMakeMoney.vue?vue&type=script&lang=js&"
export * from "./apprenticeMakeMoney.vue?vue&type=script&lang=js&"
import style0 from "./apprenticeMakeMoney.vue?vue&type=style&index=0&id=13552984&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13552984",
  null
  
)

export default component.exports